/**
 * How the song grid looks: the Studio Playground night sky, or solid black (Brian's professional
 * look). A per-device preference, set as data-grid on <html> so tokens.css can restyle the grid.
 */
export const GRID_LOOKS = [
  { id: 'sky', label: 'Night sky' },
  { id: 'black', label: 'Solid black' },
];
export const DEFAULT_GRID_LOOK = 'sky';
const STORAGE_KEY = 'ba.gridLook';

const valid = (look) => (GRID_LOOKS.some((item) => item.id === look) ? look : DEFAULT_GRID_LOOK);

export function readGridLook() {
  try { return valid(window.localStorage.getItem(STORAGE_KEY)); } catch { return DEFAULT_GRID_LOOK; }
}

export function applyGridLook(look, { remember = true } = {}) {
  const next = valid(look);
  document.documentElement.dataset.grid = next;
  if (remember) { try { window.localStorage.setItem(STORAGE_KEY, next); } catch { /* private window: still applies */ } }
  return next;
}
